export const colorGenerator = (length: number): string[] => {
	const arr = [...Array(length).map(() => '')]
	return arr.map(
		() =>
			`rgba(${Math.floor(Math.random() * 255)},${Math.floor(
				Math.random() * 255
			)},${Math.floor(Math.random() * 255)},0.8)`
	)
}
